const React = require("react");

function SearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
  }));
}

module.exports = SearchIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/SearchIcon.js
 ** module id = 605
 ** module chunks = 0
 **/